import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  Image,
  Section,
  Text
} from './../../../components'
import {
  ICONS
} from './../../../themes'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  NewsPromotionsListWrapper
} from './styled'

export class NewsPromotionsList extends React.PureComponent {
  render () {
    const {
      className,
      src,
      title,
      labelNews,
      labelPromotions,
      onClick
    } = this.props

    // props for css classes
    const classes = ClassNames(
      'news-promotions-list',
      {'is-cursor': onClick},
      className
    )

    return (
      <NewsPromotionsListWrapper
        className={classes}
        onClick={onClick}
      >
        <Section
          relative
          spacingBottom='15'
        >
          <Image src={src} />
          {(labelNews || labelPromotions) &&
            <div className={ClassNames(
              'news-promotions-list-label',
              {'is-news': labelNews},
              {'is-promotions': labelPromotions}
            )}>
              {labelNews &&
                <Image
                  widthRatio='79'
                  widthRatioUnit='px'
                  heightRatio='48'
                  heightRatioUnit='px'
                  src={ICONS['ic-label-news.svg']}
                />
              }

              {labelPromotions &&
                <Image
                  widthRatio='143'
                  widthRatioUnit='px'
                  heightRatio='62'
                  heightRatioUnit='px'
                  src={ICONS['ic-label-promotions.svg']}
                />
              }
            </div>
          }
        </Section>
        <Section>
          <Text
            bold14
            className='news-promotions-list-title'
            color={VARIABLES.COLORS.BLACK}
          >
            <span className='news-promotions-list-title-ellipsis'>
              {title}
            </span>
          </Text>
        </Section>
      </NewsPromotionsListWrapper>
    )
  }

  static defaultProps = {
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func
    className: PropTypes.string
  }
}
